const missingKeysPushInterval = 10_000 // 10 seconds

// This is some legacy junk, basically anywhere the t function is used without useTranslation outside of a hook
// it runs before the translations are setup. These are the ones I found and removed so we don't get too spammy
// with the API calls. Eventually™ when the app is fully refactored we can remove this.
const KEYS_TO_IGNORE = ['', 'manager.undefined', 'manager.timeOffs.IN_PROGRESS', 'manager.timeOffs.APPROVED', 'manager.timeOffs.REFUSED', 'English', 'Français']

type missingKeyDict = Record<
  string,
  {
    key: string
    namespace: string
    language: string
  }
>

// This dict stores all detected missing keys in the session to avoid spamming the API.
const allMissingKeys: missingKeyDict = {}
// This contains missing keys to send in the next update to the API.
let missingKeys: missingKeyDict = {}

const endpoint = `https://api.simplelocalize.io/api/v1/translations`

// Taken from https://simplelocalize.io/docs/integrations/i18next/
const missingKeyHandler = (_languages: readonly string[], namespace: string, key: string) => {
  if (KEYS_TO_IGNORE.includes(key) || Object.hasOwn(allMissingKeys, key)) return
  const missingKey = {
    key,
    namespace: namespace,
    language: 'en'
  }
  allMissingKeys[key] = missingKey
  missingKeys[key] = missingKey
}

const pushMissingKeys = async () => {
  // DO NOT PUSH MISSING KEYS IN PRODUCTION CODE
  if (process.env.NODE_ENV === 'production' || !process.env.REACT_APP_SIMPLE_LOCALIZE_API_KEY) return
  const missingKeysRequests = Object.values(missingKeys)
  if (missingKeysRequests.length > 0) {
    console.log(`[SimpleLocalize] Pushing missing keys: ${missingKeysRequests.length}`)
    fetch(endpoint, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'X-SimpleLocalize-Token': process.env.REACT_APP_SIMPLE_LOCALIZE_API_KEY
      },
      body: JSON.stringify({
        content: missingKeysRequests
      })
    })
    missingKeys = {}
  }
}

// @refresh reset
setInterval(() => pushMissingKeys(), missingKeysPushInterval)

export default missingKeyHandler
